/**
 * DBS Chevron hover
 */
window.addEventListener( 'load',  function(){
	jQuery('#dbs-chev').on('click', function(){
		jQuery(this).toggleClass('hover');
	});
});
